import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-554e0b86"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex justify-center" };
const _hoisted_2 = { class: "flex items-center justify-center gap-8 mt-12 bg-yellow-100 rounded-sm text-primary-900 w-max-content" };
const _hoisted_3 = { class: "warning-message" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.contract_term_ends')
};
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ContractTermEnds',
    props: {
        date: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const locale = computed(() => store.getters.locale);
        const formattedDate = computed(() => {
            const date = new Date(props.date);
            const dateFormatter = new Intl.DateTimeFormat(locale.value, {
                month: locale.value === 'en' ? 'short' : 'long',
                day: 'numeric',
                year: 'numeric'
            });
            return dateFormatter.format(date);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('warning_message')) + _toDisplayString(_unref(formattedDate)), 1)
                ])
            ]));
        };
    }
});
